import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

export const ImportSoci = ({ onDone }) => {
  const [file, setFile] = useState(null);
  const [email, setEmail] = useState(false);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const submit = async () => {
    if (!file) return toast.error("Seleziona il file Excel");
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("invia_email", email ? "true" : "false");
    try {
      const { data } = await api.post("/admin/soci/import", fd);
      setRes(data);
      toast.success(`${data.importati} nuovi soci, ${data.aggiornati} aggiornati`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border rounded-lg p-4 mb-6 bg-muted/30" data-testid="import-soci-panel">
      <p className="font-medium mb-1">Importa soci da Excel</p>
      <p className="text-xs text-muted-foreground mb-3">Modulo di iscrizione (.xlsx). I nuovi iscritti vengono creati con pagamento confermato, nome utente nome.cognome e tessera progressiva dopo l'ultima assegnata; per i soci già presenti (stessi cognome, nome e data di nascita) vengono aggiornati importo e tipo di pagamento.</p>
      <div className="flex flex-wrap items-center gap-3">
        <Input type="file" accept=".xlsx" className="w-64" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="import-soci-file-input" />
        <label className="text-sm flex items-center gap-2">
          <Checkbox checked={email} onCheckedChange={(v) => setEmail(!!v)} data-testid="import-soci-email-checkbox" />Invia email di attivazione con tessera
        </label>
        <Button onClick={submit} disabled={busy} data-testid="import-soci-submit-button"><Upload className="h-4 w-4 mr-1" />{busy ? "Importazione..." : "Importa"}</Button>
      </div>
      {res && (
        <p className="text-sm mt-3" data-testid="import-soci-result">
          Nuovi {res.importati}{res.ultima_tessera ? ` (ultima tessera ${res.ultima_tessera})` : ""} · aggiornati {res.aggiornati} · errori {res.errori.length}
          {res.email_in_invio && " · email in invio"}
          {res.errori.length > 0 && <span className="block text-xs text-red-600">{res.errori.map((e) => `Riga ${e.riga}: ${e.errore}`).join(" · ")}</span>}
        </p>
      )}
    </div>
  );
};
